<template>
  <component
    :is="tag"
    :style="cssStyles"
    class="form-section-label"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'form-section-label',
  props: {
    tag: {
      type: String,
      default: 'label',
      validator (value) {
        return ['label', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div'].includes(value);
      },
    },
    size: {
      type: [String, Number],
      default: 28,
    },
    lineHeight: {
      type: [String, Number],
      default: null,
    },
    lineHeightUnits: {
      type: String,
      default: 'em',
      validator (value) {
        return ['px', 'em'].includes(value);
      },
    },
  },
  computed: {
    cssStyles () {
      const styles = {
        '--fz': `${this.size}px`,
      };
      if (this.lineHeight) {
        styles['--lh'] = `${this.lineHeight}${this.lineHeightUnits}`;
      }
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-section-label {
  $fzlh_ratio: 36 / 28;

  display: block;
  padding-right: 30px;
  font-size: var(--fz, 28px);
  line-height: var(--lh, calc(var(--fz, 28px) * #{$fzlh_ratio}));
  font-weight: var(--font-2-weight, bold);
  font-family: var(--font-2);
  color: var(--v-navy-dark-base, $clr-navy-dark);

  &::v-deep {
    & + .form-section-question {
      margin-top: 7px;
    }

    & + * {
      margin-top: 18px;
    }
  }
}

@media screen and (min-width: 768px) {
  .form-section-label {
    padding-right: 0;
  }
}
</style>
